import { useMutation } from '@tanstack/react-query';
import { autoLinkMoodleMappings } from '../../../services/MoodleService';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION } from '../../../constants';

export const useAutoLinkMoodleMappings = () => {
  const dispatch = useDispatch();

  const { mutate, isPending } = useMutation({
    mutationFn: autoLinkMoodleMappings,
    onSuccess: (data) => {
      if (
        data?.statusCode === 200 ||
        data?.statusCode === 201 ||
        !data?.statusCode
      ) {
        const linkedCount = data?.linkedCount ?? 0;
        dispatch({
          type: SHOW_NOTIFICATION,
          data: {
            message: `Successfully linked ${linkedCount} account${linkedCount === 1 ? '' : 's'}`,
            type: 'success',
            open: true,
          },
        });
      } else {
        dispatch({
          type: SHOW_NOTIFICATION,
          data: {
            message: 'Failed to auto-link moodle mappings',
            type: 'error',
            open: true,
          },
        });
      }
    },
    onError: () => {
      dispatch({
        type: SHOW_NOTIFICATION,
        data: {
          message: 'An error occurred while auto-linking moodle mappings',
          type: 'error',
          open: true,
        },
      });
    },
  });

  return { mutate, isPending };
};
